import React, { useRef, useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";


const API_KEY = "x7mzrfz9lvyglwter7lw6kynmzjehi34yyvocekauzvn4rq8";
const TinyMCETextArea = ({ id, name, value, onChange, rows = 4 }) => {
  console.log("API key", API_KEY);

  const editorRef = useRef(null);
  const [content, setContent] = useState(value || "");

  // Update parent form data when content changes
  const handleEditorChange = (newContent) => {
    setContent(newContent);
    if (onChange) {
      // Synthetic event to mimic <textarea> behavior
      onChange({
        target: { name, value: newContent },
      });
    }
  };

  // Update editor if parent value changes
  useEffect(() => {
    if (value !== content) {
      setContent(value || "");
    }
  }, [value]);

  return (
    <div className="mb-3">
      <label htmlFor={id} className="form-label">
        Description *
      </label>
      <Editor
        id={id}
        apiKey={API_KEY}
        value={content}
        onEditorChange={handleEditorChange}
        init={{
          height: rows * 40, // Roughly rows x 40px
          menubar: true,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount",
          ],
          toolbar:
            "undo redo | formatselect | bold italic backcolor | " +
            "alignleft aligncenter alignright alignjustify | " +
            "bullist numlist outdent indent | removeformat | help",
        }}
      />
    </div>
  );
};

export default TinyMCETextArea;
